"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dm.communicationType.wa': 'WA',
    'whatsapp.dm.loading': 'Caricamento...',
    'whatsapp.dm.back': 'Indietro',
    'whatsapp.dm.contactInfo': 'Info contatto',
    'whatsapp.dm.contactName': 'Nome',
    'whatsapp.dm.contactId': 'ID contatto',
    'whatsapp.dm.messages': 'Messaggi',
    'whatsapp.dm.noMessages': 'Nessun messaggio trovato per questo intervallo di date.',
    'whatsapp.dm.dateFrom': 'Da',
    'whatsapp.dm.dateTo': 'A',
    'whatsapp.dm.summarize': 'Riassumi',
    'whatsapp.dm.summarizeDone': 'Riepilogo DM generato con successo.',
    'whatsapp.dm.summarizeFailed': 'Impossibile generare il riepilogo DM.',
    'whatsapp.dm.botSender': 'Bot',
    'whatsapp.dm.media.attachment': 'Allegato',
    'whatsapp.dm.summaries.title': 'Riepiloghi',
    'whatsapp.dm.summaries.empty': 'Nessun riepilogo ancora.',
    'whatsapp.dm.summaries.date': 'Data',
    'whatsapp.dm.summaries.excerpt': 'Estratto',
    'whatsapp.dm.summaries.modalTitle': 'Riepilogo DM',
    'whatsapp.dm.stats.contacts': 'Contatti',
    'whatsapp.dm.stats.total': 'Totale',
    'whatsapp.dm.syncMessages.button': 'Sincronizza messaggi',
    'whatsapp.dm.syncMessages.failed': 'Impossibile sincronizzare i messaggi.',
};
